import React, { memo, forwardRef } from "react";
const SvgAlphabetO = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M21.22 15.96c0 .76-.14 1.453-.42 2.08a4.91 4.91 0 01-1.1 1.62c-.467.44-1.02.787-1.66 1.04-.64.253-1.32.38-2.04.38s-1.4-.127-2.04-.38a5.157 5.157 0 01-1.66-1.04 5.173 5.173 0 01-1.12-1.62c-.267-.627-.4-1.32-.4-2.08s.133-1.447.4-2.06c.28-.627.653-1.16 1.12-1.6.466-.44 1.02-.78 1.66-1.02.64-.24 1.32-.36 2.04-.36s1.4.12 2.04.36c.64.24 1.193.58 1.66 1.02.466.44.833.973 1.1 1.6.28.613.42 1.3.42 2.06zm-2.44 0c0-.373-.06-.74-.18-1.1a2.938 2.938 0 00-.5-1 2.46 2.46 0 00-.86-.7c-.347-.187-.76-.28-1.24-.28s-.893.093-1.24.28a2.46 2.46 0 00-.86.7c-.227.293-.4.627-.52 1-.107.36-.16.727-.16 1.1 0 .373.053.747.16 1.12.12.373.293.707.52 1 .226.293.513.533.86.72.347.187.76.28 1.24.28s.893-.093 1.24-.28a2.67 2.67 0 00.86-.72c.226-.293.393-.627.5-1 .12-.373.18-.747.18-1.12z"
      />
    </svg>
  );
});
SvgAlphabetO.displayName = "SvgAlphabetO";
const MemoForwardRef = memo(SvgAlphabetO);
export default MemoForwardRef;
